import { apiInvoker } from '../../lib/apiInvoker';
import { API_URLS } from '../../lib/apiUrls';
import { 
  fetchCompetitorChannelsStart,
  fetchCompetitorChannelsSuccess,
  fetchCompetitorChannelsFailure,
  fetchChannelComparisonStart,
  fetchChannelComparisonSuccess,
  fetchChannelComparisonFailure,
} from '../slices/competitorChannelsSlice';
import { handleApiError } from '../../utils/errorHandler';

export const fetchCompetitorChannels = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchCompetitorChannelsStart());
      const url = API_URLS.USER.COMPETITOR_CHANNELS();
      const response = await apiInvoker.get(url);
      
      if (response?.success && response?.data) {
        dispatch(fetchCompetitorChannelsSuccess(response.data));
      } else if (response && !response.success) {
        throw new Error(response?.message || 'Failed to fetch competitor channels');
      } else if (response) {
        dispatch(fetchCompetitorChannelsSuccess(response));
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Competitor channels fetch error:', error);
      
      const { message: errorMessage } = handleApiError(error, {
        defaultMessage: 'Failed to fetch competitor channels',
        skipToastForStatus: [401, 403],
      });
      
      dispatch(fetchCompetitorChannelsFailure(errorMessage));
    }
  };
};

export const searchCompetitorChannels = (query) => {
  return async (dispatch) => {
    try {
      if (!query || query.trim() === '') {
        return [];
      }
      const url = API_URLS.USER.SEARCH_COMPETITOR_CHANNELS(query.trim());
      const response = await apiInvoker.get(url);
      let channels = [];
      
      if (response?.success && response?.data) {
        if (response.data.channels && Array.isArray(response.data.channels)) {
          channels = response.data.channels;
        }
        else if (Array.isArray(response.data)) {
          channels = response.data;
        }
      }
      else if (response?.data?.channels && Array.isArray(response.data.channels)) {
        channels = response.data.channels;
      }
      else if (response?.channels && Array.isArray(response.channels)) {
        channels = response.channels;
      }
      else if (Array.isArray(response)) {
        channels = response;
      }
      else if (response?.data && Array.isArray(response.data)) {
        channels = response.data;
      }
      
      return channels;
    } catch (error) {
      return [];
    }
  };
};

export const fetchChannelComparison = (competitorUrls) => {
  return async (dispatch) => {
    try {
      dispatch(fetchChannelComparisonStart());
      const url = API_URLS.USER.CHANNEL_COMPARISON();
      const body = {
        competitor: Array.isArray(competitorUrls) ? competitorUrls : [competitorUrls]
      };
      const response = await apiInvoker.post(url, body);
      
      if (response?.success && response?.data) {
        dispatch(fetchChannelComparisonSuccess(response.data));
      } else if (response && !response.success) {
        throw new Error(response?.message || 'Failed to fetch channel comparison');
      } else if (response) {
        dispatch(fetchChannelComparisonSuccess(response));
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Channel comparison fetch error:', error);
      
      const { message: errorMessage } = handleApiError(error, {
        defaultMessage: 'Failed to fetch channel comparison',
        skipToastForStatus: [401, 403],
      });
      
      dispatch(fetchChannelComparisonFailure(errorMessage));
    }
  };
};

